/* eslint-disable @typescript-eslint/ban-types */

export function swallow<A extends unknown[], R>(
  fn: (...args: A) => R,
  ...errorTypes: Function[]
): (...args: A) => R | undefined;

export function swallow<A extends unknown[], R>(
  fn: (...args: A) => Promise<R>,
  ...errorTypes: Function[]
): (...args: A) => Promise<R | undefined>;

export function swallow<A extends unknown[], R>(
  fn: (...args: A) => R | Promise<R>,
  ...errorTypes: Function[]
): (...args: A) => R | undefined | Promise<R | undefined> {
  return (...args: A) => {
    let result: R | Promise<R>;

    try {
      result = fn(...args);
    } catch (error) {
      return handleError(error, ...errorTypes);
    }

    if (result instanceof Promise)
      return result.catch((error) => handleError(error, ...errorTypes));
    return result;
  };
}

function handleError(error: unknown, ...errorTypes: Function[]): undefined {
  for (const errorType of errorTypes)
    if (error instanceof errorType) return undefined;
  throw error;
}
